import { numberFormat } from '../../utils/formats/formats'

export const rechargeResponseColumns = [
  {
    Header: 'Colaborador',
    accessor: 'sEmpleado', // accessor is the "key" in the data
  },
  {
    Header: 'Tarjeta',
    accessor: 'sTarjeta', // accessor is the "key" in the data
  },
  {
    Header: 'Monto',
    accessor: 'nMonto', // accessor is the "key" in the data
  },
]

export const rechargeTypes = [
  {
    id: 'INMEDIATA',
    value: 'INMEDIATA',
    label: 'Recarga Inmediata',
  },
  {
    id: 'PROGRAMADA',
    value: 'PROGRAMADA',
    label: 'Recarga Programada',
  },
]

export const calculateAmount = (array) => {
  return (
    array.reduce((acc, el) => acc + numberFormat(el.nMonto, 'number'), 0) || 0
  )
}
export const formatDniData = (values, sEmpresa) => {
  return {
    cEmpleados:
      values.cEmpleados.map((item) => ({
        nMonto: item.nMonto,
        sEmpleado: item.sEmpleado,
        sTarjeta: '',
        sComentario: '',
      })) || [],
    sCentroCosto: values.sCentroCosto,
    sSucursal: values.sSucursal,
    sTipoRecarga: values.sTipoRecarga,
    sFechaProgramacion: values.sFechaProgramacion,
    sEmpresa,
    nMontoTotal: values.nMontoTotal,
  }
}
